<!-- Citations for TDM Studio -->
<div id="MLA" class="cite"><i>TDM Studio.</i> ProQuest part of Clarivate, Ann Arbor, MI, USA.  https://tdmstudio.proquest.com. Date or Range of Dates Accessed.</div>
<div id="APA" class="cite"><i>TDM Studio.</i> ProQuest part of Clarivate, Ann Arbor, MI, USA.  https://tdmstudio.proquest.com.</div>
<div id="Chicago" class="cite"><i>TDM Studio, Date or Range of Dates Accessed, https://tdmstudio.proquest.com.</i></div>

<div class="close-icon">
    <img class="icon" 
    src="../assets/images/close.svg" 
    alt="close icon" 
    role="button"
    aria-label="Close help and learn section" tabindex="0" (keyup.enter)="close()"   (click)="close()">
</div>

<div class="onboard-container">
    <img class="banner-content-img" src="../assets/images/person.png"  role="img" aria-hidden="true" alt="">
    <div class="banner-content-wrapper">
        <div class="banner-content-info-0">
            <div  class="product-questions">Guides</div>
            <a href="https://about.proquest.com/globalassets/proquest/files/toolkits/tdm-quick-guide-2022-nov.pdf" target="_blank" aria-label="Quick Start Guide">Quick Start Guide </a>
            <a href="https://proquest.libguides.com/tdmstudio#s-lg-box-25541893" target="_blank" aria-label="Videos">Videos</a>
            <a href="https://proquest.libguides.com/tdmstudio" target="_blank" aria-label="Documentation (LibGuide)">Documentation (LibGuide)</a>
        </div>                
        <div class="banner-content-info-1">
            <div class="banner-title-1-row">
                 <i class="bi bi-calendar-check"></i>
                 <a class="banner-title-1" href="https://outlook.office365.com/owa/calendar/TDMStudioOnboarding@clarivate.com/bookings/" target="_blank" aria-label="Schedule session booking for TDM Studio Onboarding">Schedule a personalized onboarding session</a>
                 <a href="https://outlook.office365.com/owa/calendar/TDMStudioOnboarding@clarivate.com/bookings/" target="_blank" aria-label="Schedule session booking for TDM Studio Onboarding"><i class="bi bi-box-arrow-up-right"></i></a>
            </div>     
            <div class="banner-text">1. Choose a time to meet with one of our experts.</div>
            <div class="banner-text">2. Join the online session tailored to your project.</div>
            <div class="banner-title-1-row">
                <i class="bi bi-play-btn"></i>
                <a class="banner-title-1" href="https://share.vidyard.com/watch/GdyeQtdPF4uZMtmyVvJtoc?" target="_blank" aria-label="watch the recorded onboarding session">Recorded onboarding session</a>
                <a href="https://share.vidyard.com/watch/GdyeQtdPF4uZMtmyVvJtoc?" target="_blank" aria-label="watch the recorded onboarding session"><i class="bi bi-box-arrow-up-right"></i></a>
           </div>  
        </div>
        <div class="banner-content-info-2">
            <div  class="product-questions">Product Questions</div>
            <a href="https://proquest.libguides.com/ld.php?content_id=74086531" class="email" target="_blank" aria-label="TDM Studio FAQ">TDM Studio FAQ</a>
            <div  class="banner-text padding">Email us at <a href = "mailto: tdmstudio@clarivate.com" class="email" aria-label="Email us at tdmstudio@clarivate.com">tdmstudio&#64;clarivate.com</a></div>
        </div>

        <!-- Citation-Info -->
        <div class="banner-content-info-2">
            <div  class="product-questions">Want to cite TDM Studio?</div>
            <p class="banner-text">Select a format listed below to copy a citation to your clipboard.</p>
            <div  class="btn-container">
                <button class="citation-btn" (click)="copy('MLA')" (keydown.enter)="copy('MLA')" aria-label="Copy MLA citation to clipboard">
                    <mat-icon fontSet="material-symbols-outlined" class="copyIcon">content_copy</mat-icon>
                    <p>MLA</p>
                </button>
                <button class="citation-btn" (click)="copy('APA')" (keydown.enter)="copy('APA')" aria-label="Copy APA citation to clipboard">
                    <mat-icon fontSet="material-symbols-outlined"  class="copyIcon">content_copy</mat-icon>
                    <p>APA</p>
                </button>
                <button class="citation-btn" (click)="copy('Chicago')" (keydown.enter)="copy('Chicago')" aria-label="Copy Chicago citation to clipboard">
                    <mat-icon fontSet="material-symbols-outlined" class="copyIcon">content_copy</mat-icon>
                    <p>Chicago</p>
                </button>
            </div>
            <div class="copied" *ngIf="isMlaCopied" role="alert">Copied!</div>
            <div class="copied apa-space" *ngIf="isApaCopied" role="alert">Copied!</div>
            <div class="copied chicago-space" *ngIf="isChicagoCopied" role="alert">Copied!</div>
        </div>
    </div>
</div>